import { useQuery } from 'react-query'
import { fetcher } from 'src/fetcher'
import { BASE_API_URL } from 'src/globals'
import logger from 'src/logger'

type Appointment = {
    id: string
    date: string
}

type AppointmentsResponse = {
    appointments: Appointment[]
}

type UseOpenLoopAppointmentsParams = {
    serviceLine: string
}

export function useOpenLoopAppointments({
    serviceLine
}: UseOpenLoopAppointmentsParams): {
    isLoading: boolean
    appointments?: Appointment[]
} {
    const query = useQuery<AppointmentsResponse>(
        ['openloop-appointments', serviceLine],
        async () => {
            const params = new URLSearchParams({
                serviceLine
            })

            const url = `${BASE_API_URL}/awell-api/open-loop/appointments?${params.toString()}`

            const data = await fetcher(url, undefined, undefined, {
                customErrorHandler: (res: Response) => {
                    res.text().then(body => {
                        logger.error(`OpenLoop - appointments fetch`, {
                            status: res.status,
                            errorBody: body
                        })
                    })
                    return new Error('Server returned not-ok')
                }
            })
            return data
        },
        {
            cacheTime: Infinity
        }
    )

    return {
        isLoading: query.isLoading,
        appointments: query.data?.appointments
    }
}
